import React from "react";
import { Button } from "@/components/ui/button";
import { X } from "lucide-react";

const STATUS_BADGES = {
  draft: { label: "Draft", cls: "bg-[#F3F4F6] text-[#374151] border-[#9CA3AF]/30" },
  pending_approval: { label: "Pending Approval", cls: "bg-[#FFF7E6] text-[#B45309] border-[#F59E0B]/40" },
  approved: { label: "Approved", cls: "bg-[#E8F5E9] text-[#2E7D32] border-[#2E7D32]/30" },
  rejected: { label: "Rejected", cls: "bg-[#FDECEA] text-[#C62828] border-[#C62828]/30" },
};

/** Read-only view of a single Progress Feedback entry. */
export default function FeedbackViewDialog({ open, onClose, feedback }) {
  if (!open || !feedback) return null;
  const badge = STATUS_BADGES[feedback.status] || STATUS_BADGES.draft;
  return (
    <div className="fixed inset-0 bg-black/40 z-50 flex items-center justify-center p-4" onClick={onClose} data-testid="pf-view-dialog">
      <div className="bg-white rounded-3xl max-w-2xl w-full max-h-[90vh] overflow-y-auto shadow-2xl" onClick={(e) => e.stopPropagation()}>
        <div className="p-5 border-b border-brand-purple/10 flex items-start justify-between">
          <div>
            <p className="text-[11px] uppercase tracking-wider text-brand-purple font-heading font-bold">Progress Feedback</p>
            <h2 className="font-heading text-2xl font-bold text-foreground">{feedback.title}</h2>
            {feedback.sub_title && <p className="text-sm text-brand-inkMuted mt-0.5">{feedback.sub_title}</p>}
            <p className="text-xs text-brand-inkMuted mt-1">
              For: <span className="font-heading font-semibold text-foreground uppercase">{feedback.student_name}</span>
              <span className="mx-2">·</span> {feedback.date}
            </p>
          </div>
        </div>

        <div className="px-5 pt-3">
          <span className={`inline-flex items-center text-xs font-heading font-bold px-2.5 py-1 rounded-full border ${badge.cls}`} data-testid="pf-view-status">
            {badge.label}
          </span>
          {feedback.status === "rejected" && feedback.rejection_reason && (
            <div className="mt-3 rounded-xl border border-[#C62828]/30 bg-[#FDECEA] p-3 text-sm text-[#C62828]">
              <strong className="font-heading">Rejection reason:</strong> {feedback.rejection_reason}
            </div>
          )}
        </div>

        <div className="p-5">
          <p className="text-[11px] uppercase tracking-wider text-brand-inkMuted font-heading">Feedback</p>
          <p className="mt-2 text-sm text-foreground whitespace-pre-wrap leading-relaxed" data-testid="pf-view-body">{feedback.feedback}</p>
        </div>

        <div className="px-5 pb-5 text-xs text-brand-inkMuted">
          <p>Created by <span className="font-heading text-foreground">{feedback.created_by_name || "—"}</span> on {(feedback.created_at || "").slice(0, 10)}</p>
          {feedback.approved_at && <p>Approved on {feedback.approved_at.slice(0, 10)}</p>}
          {feedback.rejected_at && <p>Rejected on {feedback.rejected_at.slice(0, 10)}</p>}
        </div>

        <div className="p-5 border-t border-brand-purple/10 flex justify-end">
          <Button onClick={onClose} className="rounded-2xl bg-brand-purple hover:bg-brand-purpleHover text-white">Close</Button>
        </div>
      </div>
    </div>
  );
}

export { STATUS_BADGES };
